<template>
  <div id="app">
    <!-- <router-view /> -->
    <Empty style="margin-top: 1rem" v-if="!online" image="network" description="内容加载失败，请检查网络" />
    <template v-else>
      <keep-alive>
        <router-view v-if="$route.meta.keepAlive"></router-view>
      </keep-alive>

      <router-view v-if="!$route.meta.keepAlive"></router-view>
    </template>
  </div>
</template>
<script>
import { Empty } from "vant";
export default {
  components: {
    Empty
  },
  data() {
    return {
      online: true
    };
  },
  watch: {
    $route(to) {
      document.title = `${to.meta.title}`; //第一种方法
    }
  },
  mounted() {
    // this.init()
    // window.addEventListener("online", this.onlineHandle);
    // window.addEventListener("offline", this.offlineHandle);
    // 支付宝小程序
    // if (!sessionStorage.getItem("alipay")) {
    //   this.getAppVersion();
    // }
    // 苏周到H5
    // this.getAppVersion();
  },
  beforeDestroy() {
    // window.removeEventListener("online", this.onlineHandle);
    // window.removeEventListener("offline", this.offlineHandle);
  },
  methods: {
    init() {
      let _this = this;
      var geolocation = new qq.maps.Geolocation(
        "OB4BZ-D4W3U-B7VVO-4PJWW-6TKDJ-WPB77",
        "myapp"
      );
      geolocation.getLocation(_this.showPosition, _this.showError);
    },
    showPosition(position) {
      console.log(position);
      let payload = {
        lng: position.lng,
        lat: position.lat
      };
      this.$store.commit("lngLat/setPosition", payload);
    },
    showError(err) {
      console.log(err);
    },
    onlineHandle() {
      this.online = true;
    },
    offlineHandle() {
      this.online = false;
    },
    getAppVersion() {
      let _this = this;
      getNativeInfo(res => {
        if (res) {
          let appversion = JSON.parse(res).appVersion || "0";
          let v = appversion.replace(/[.]/g, "").padEnd(4, "0");
          _this.$store.commit("setAppversion", v);
          _this.$store.commit("setAppversionString", appversion);
        }
      });
    }
  }
};
</script>
<style lang="less">
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}
html {
  // background:rgba(248,248,248,1);
  // -webkit-filter: grayscale(100%);
}
html,
body {
  width: 100%;
  height: 100%;
  margin: 0;
  padding: 0;
  position: relative;
}
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;

  //  会造成window.scrollTo(0,0)失效
  // width: 100%;
  // height: 100%;
  // overflow: scroll;
  // -webkit-overflow-scrolling: touch;
  // position: absolute;
  // left: 0;
  // top: 0;
}

#nav {
  padding: 30px;

  a {
    font-weight: bold;
    color: #2c3e50;

    &.router-link-exact-active {
      color: #42b983;
    }
  }
}
.flexColumn {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
.flexVertical {
  display: flex;
  justify-content: center;
  align-items: center;
}
.van-pull-refresh {
  min-height: 80vh;
}

.van-cell input {
  font-size: 16px;
}
</style>
